'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var EMAIL_MESSAGE_ID = exports.EMAIL_MESSAGE_ID = ['metadata', 'conversationsEmailMessage', 'messageId'];
var CONNECTED_ACCOUNT_ADDRESS = exports.CONNECTED_ACCOUNT_ADDRESS = ['metadata', 'conversationsEmailMessage', 'connectedAccountAddress'];

var PLAIN_TEXT = exports.PLAIN_TEXT = ['metadata', 'conversationsEmailMessage', 'plainText'];
var RICH_TEXT = exports.RICH_TEXT = ['metadata', 'conversationsEmailMessage', 'html'];
var FROM_EMAIL = exports.FROM_EMAIL = ['metadata', 'conversationsEmailMessage', 'from', 'email'];
var TO = exports.TO = ['metadata', 'conversationsEmailMessage', 'to'];
var CC = exports.CC = ['metadata', 'conversationsEmailMessage', 'cc'];
var BCC = exports.BCC = ['metadata', 'conversationsEmailMessage', 'bcc'];
var STATUS = exports.STATUS = ['metadata', 'conversationsEmailMessage', 'status'];
var ATTACHMENTS = exports.ATTACHMENTS = ['metadata', 'conversationsEmailMessage', 'attachments'];
var SUBJECT = exports.SUBJECT = ['metadata', 'conversationsEmailMessage', 'subject'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/email-message-metadata/constants/keyPaths.js
// module id = 365
// module chunks = 2 3